import React, { PureComponent } from 'react'
import cx from 'classnames'
import Link from 'components/ui/Link/Link'

import s from './Button.scss'


class Button extends PureComponent {

  handleClick = (e) => {
    const { onClick } = this.props

    if (typeof onClick=== 'function') {
      e.preventDefault()
      e.stopPropagation()

      onClick()
    }
  }

  render() {
    const {
      children,
      className,
      title,
      to,
      toOLD,
      toTAB,
      download,
      green, greenInverted, // deprecated
      color,
      fullWidth, fullWidthOnMobile, uppercase, disabled,
      type,
      size = 'md',
      weight,
    } = this.props

    const buttonClassName = cx(s.button, className, {
      [s.md]: size === 'md',
      [s.sm]: size === 'sm',

      [s.green]: green,
      [s.greenInverted]: greenInverted,
      [s[color]]: color,
      [s.disabled]: disabled,

      [s.semibold]: weight === 'semibold',
      [s.uppercase]: uppercase,
      [s.fullWidth]: fullWidth,
      [s.fullWidthOnMobile]: fullWidthOnMobile,
    })

    if (type === 'submit') {
      return (
        <button
          className={buttonClassName}
          type={type}
          onClick={this.handleClick}
        >
          <div>
            {
              Boolean(title)
                ? title
                : children
            }
          </div>
        </button>
      )
    }

    return (
      <Link
        className={buttonClassName}
        to={to}
        toOLD={toOLD}
        toTAB={toTAB}
        download={download}
        onClick={this.handleClick}
      >
        <div>
          {
            Boolean(title)
              ? title
              : children
          }
        </div>
      </Link>
    )
  }
}


export default React.memo(Button)
